import '@app/App.css';
import { Breadcrumb, BreadcrumbItem, BreadcrumbList, BreadcrumbSeparator } from '@comps/ui/Breadcrumb';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@comps/ui/dropdownmenu';
import { removeSelectedViewKey, setSelectedObjectKey, setSelectedViewKey } from '@utils/localStorage';
import { TW_Breadcrumb, TW_BreadcrumbItem } from '@utils/twClasses';
import { ArrowSquareLeft, Home3 } from 'iconsax-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useModelStore } from 'src/store';

function AppBreadcrumb() {

  const workspace = useModelStore(state => state.selectedWorkspace);
  const wsIsDarkColor = useModelStore(state => state.wsIsDarkColor);
  const objectInfos = useModelStore(state => state.selectedObjectInfos);
  const allObjectInfos = useModelStore(state => state.objectInfos);
  const view = useModelStore(state => state.selectedView);
  const selectWorkspace = useModelStore(state => state.selectWorkspace);
  const selectObject = useModelStore(state => state.selectObjectInfos);
  const selectView = useModelStore(state => state.selectView);
  const navigate = useNavigate();
  const [homeHover, setHomeHover] = useState(false);

  if (!workspace) {
    return null;
  }

  const onObjectClick = (objKey: string) => {
    const o = allObjectInfos.find(o => o.object._key === objKey);
    const currentObjKey = objectInfos?.object._key;
    if (o && (currentObjKey !== objKey || view)) {
      selectObject(o, null, null);
      setSelectedObjectKey(workspace?._key, objKey);
      removeSelectedViewKey(workspace?._key);
    }
  }

  const onViewClick = (objKey: string, viewKey: string) => {
    const o = allObjectInfos.find(o => o.object._key === objKey);
    const v = o?.views?.find(v => v._key === viewKey);
    const currentViewKey = view?._key;
    if (o && v && currentViewKey !== viewKey) {
      selectView(o, v, null);
      setSelectedViewKey(workspace?._key, viewKey);
    }
  }

  const onHomeClick = () => {
    selectWorkspace(null);
    navigate('/');
  }

  return (
    <Breadcrumb className={TW_Breadcrumb}>
      <BreadcrumbList>
        <BreadcrumbItem key="breadcrumb-home" className={TW_BreadcrumbItem + (wsIsDarkColor ? ' text-white' : '')} onMouseEnter={() => setHomeHover(true)} onMouseLeave={() => setHomeHover(false)}>
          {homeHover ? (
            <ArrowSquareLeft size={24} className={wsIsDarkColor ? 'text-white' : 'text-black'} onClick={onHomeClick}/>
          ) : (
            <Home3 size={24} className={wsIsDarkColor ? 'text-white' : 'text-black'} onClick={onHomeClick}/>
          )}
        </BreadcrumbItem>
        {objectInfos && (
          <>
            <BreadcrumbSeparator className={wsIsDarkColor ? 'text-white' : 'text-black'}/>
            <BreadcrumbItem key="breadcrumb-object">
              <DropdownMenu>
                <DropdownMenuTrigger className={TW_BreadcrumbItem + (wsIsDarkColor ? ' text-white' : '')}>
                  {objectInfos.object.name}
                </DropdownMenuTrigger>
                <DropdownMenuContent align="start">
                  {allObjectInfos.map((o) => (
                    <DropdownMenuItem key={"breadcrumb-object-item-" + o.object._key} className={TW_BreadcrumbItem} onClick={() => onObjectClick(o.object._key)}>{o.object.name}</DropdownMenuItem>
                  ))}
                </DropdownMenuContent>
              </DropdownMenu>
            </BreadcrumbItem>
          </>
        )}
        {objectInfos && view && (
          <>
            <BreadcrumbSeparator className={wsIsDarkColor ? 'text-white' : 'text-black'}/>
            <BreadcrumbItem key="breadcrumb-view">
              <DropdownMenu>
                <DropdownMenuTrigger className={TW_BreadcrumbItem + (wsIsDarkColor ? ' text-white' : '')}>
                  {view.name}
                </DropdownMenuTrigger>
                <DropdownMenuContent align="start">
                  {objectInfos.views.map((v) => (
                    <DropdownMenuItem key={"breadcrumb-view-item-" + v._key} className={TW_BreadcrumbItem} onClick={() => onViewClick(objectInfos.object._key, v._key)}>{v.name}</DropdownMenuItem>
                  ))}
                </DropdownMenuContent>
              </DropdownMenu>
            </BreadcrumbItem>
          </>
        )}
      </BreadcrumbList>
    </Breadcrumb>
  );
};

export default AppBreadcrumb;